import {  Result } from "antd";

export const CustomEmptyState = () => {
    return <Result status="404" subTitle="Desculpe, dados não encontrados." />;
  };